module.exports = __webpack_public_path__ + "img/service-dashuju3.5a280c49.svg";